import type { OnRedirectParams } from '../../../types'

export enum ViewType {
  accountSelection = 'account-selection',
  FacebookGroups = 'facebook-groups',
}

export type AccountTypeSelectionProps = {
  onRedirect: (args: OnRedirectParams) => void
  closeAction: () => void
}

export type DefaultViewProps = {
  onRedirect: (args: OnRedirectParams) => void
  onChangeView: (nextView: ViewType) => void
}
